import { useGetTicketInfo } from '../../../hooks/useGetTicketInfo';
import { TicketDetailsTabHeader } from './TicketDetailsTabHeader/TicketDetailsTabHeader';
import { TicketInfo } from './TicketInfo/TicketInfo';
import {
  TicketDetailsContentWrapper,
  TicketDetailsWrapper,
  TicketDivider,
} from './TicketDetailsPopup.styled';
import { TicketDetailsNotesSection } from './TicketDetailsNotesSection/TicketDetailsNotesSection';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const TicketDetailsPopup = () => {
  const { ticketOwner, viewTicketId, toggleTicketDetails } =
    useServiceDeskContext();
  const { formattedTicketData, loadingTicket } = useGetTicketInfo(viewTicketId);

  const handleClose = () => {
    toggleTicketDetails(viewTicketId, ticketOwner, false);
  };

  if (loadingTicket) {
    return (
      <TicketDetailsWrapper>
        <TicketDetailsTabHeader onClose={handleClose} />
        <LoadingSpinner />
      </TicketDetailsWrapper>
    );
  }

  return (
    <TicketDetailsWrapper>
      <TicketDetailsTabHeader onClose={handleClose} />
      <TicketDetailsContentWrapper>
        <TicketDetailsNotesSection
          axsTicketId={viewTicketId}
          ticketOwner={ticketOwner}
        />
        <TicketDivider vertical />
        <TicketInfo
          ticketInfo={formattedTicketData}
          onClose={handleClose}
          ticketOwner={ticketOwner}
        />
      </TicketDetailsContentWrapper>
    </TicketDetailsWrapper>
  );
};
